import React, { useEffect } from 'react';
import styled from 'styled-components';
import SuccessIcon from 'static/success.svg';
import H1 from 'components/text/H1';
import analytics from 'lib/analytics';
import application from 'lib/application';

const ThankYouWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  
  img {
    margin-top: ${props => props.theme.paddingM};
    margin-bottom: ${props => props.theme.paddingS}
  }
`

const ThankYou = () => {
  useEffect(() => {
    // clear cookies & local storage
    application.clear()
    analytics.reset()
  }, [])
  
  return (
    <ThankYouWrapper>
      <img src={SuccessIcon} alt="Success!" height="56px" width="56px"/>
      <H1>Thank you for your application</H1>
      <p>Your application is being reviewed by the LedgerX compliance team. You will hear from us soon!</p>
      <p>To learn more about LedgerX, please visit our <a href="https://support.ledgerx.com">helpdesk</a>.</p>
    </ThankYouWrapper>
  );
}

export default ThankYou;
